
import { Link } from 'react-router-dom';

const NewsSection = () => {
  const news = [
    {
      id: 1,
      title: 'Você sabe o que é Food Service?',
      excerpt: 'Uma das principais vertentes da Sustentare é justamente o setor de Food Service. Descubra como podemos ajudar seu negócio.',
      date: '22 November',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f337a6b15156ffd0f0e4275f2501032b.jpeg',
      category: 'Food Service',
      link: '/noticias/1'
    },
    {
      id: 2,
      title: 'Treinamentos e parcerias Sustentare com os clientes',
      excerpt: 'A Sustentare quer ser mais que uma simples fornecedora de produtos, queremos ser sua parceira no desenvolvimento do seu negócio.',
      date: '22 November',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/78604d84acb680cdeb1ec830c9be7ab5.jpeg',
      category: 'Parcerias',
      link: 'https://www.tecnutrifoodservice.com.br/'
    },
    {
      id: 3,
      title: 'Tecnutri Food Service lança nova linha de embalagens',
      excerpt: 'Embalagens chegam nos pdvs em maio com design moderno e funcionalidade aprimorada para melhor experiência do cliente.',
      date: '22 May',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8b36a852c35afd1a18cc23436111c9a6.png',
      category: 'Lançamentos',
      link: 'https://www.tecnutrifoodservice.com.br/'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Notícias
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fique por dentro das últimas novidades, lançamentos e acontecimentos da Sustentare. 
            Acompanhe nosso crescimento e inovações no setor alimentício.
          </p>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {news.map((article) => (
            <article key={article.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
              {/* Image */}
              <div className="aspect-video overflow-hidden relative">
                <img 
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-blue-600 text-white text-sm font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-white/90 text-gray-900 text-sm font-medium rounded-full">
                    {article.date}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-6 line-clamp-3">
                  {article.excerpt}
                </p>
                {article.link.startsWith('http') ? (
                  <a 
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-colors whitespace-nowrap"
                  >
                    Leia Mais
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                ) : (
                  <Link 
                    to={article.link}
                    className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-colors whitespace-nowrap"
                  >
                    Leia Mais
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                )}
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link 
            to="/noticias"
            className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            Ver Todas as Notícias
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
